export default {
    Backspace: 8,
    Tab: 9,
    Delete: 46,
    ZeroDigit: 48,
    NineDigit: 57,
    A: 65,
    C: 67,
    V: 86,
    X: 88,
    Numpad0: 96,
    Numpad9: 105,
    F1: 112,
    F12: 123,
    Period: 190,
    Subtract: 109,
    DecimalPoint: 110,
    Comma: 188,
    Dash: 189,
  };
  